import loadableWithRetry from '../common/loadableWithRetry'

const BookingForm = loadableWithRetry(() => import('./BookingForm'));

export default BookingForm;
